var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "header-wrapper" }, [
    _c("div", { staticClass: "page-content" }, [
      _c(
        "div",
        { staticClass: "header" },
        [
          _c(
            "span",
            {
              staticClass: "code-text",
              on: { mouseover: _vm.showQrcode, mouseleave: _vm.hideQrcode }
            },
            [
              _c("i", { staticClass: "icon-erweima" }),
              _vm._v("扫码下载会生意App\n        "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showCode,
                      expression: "showCode"
                    }
                  ],
                  staticClass: "qrcode"
                },
                [_c("img", { attrs: { src: _vm.qrcode } })]
              )
            ]
          ),
          _vm._v(" "),
          _c("span", { staticClass: "notice", on: { click: _vm.toNotice } }, [
            _c("i", {
              staticClass: "el-icon-bell",
              staticStyle: { "font-size": "15px", "font-weight": "bold" }
            }),
            _vm._v("消息")
          ]),
          _vm._v(" "),
          _vm.visible && _vm.msgNum
            ? _c("div", { staticClass: "notice-box" }, [
                _c("p", [
                  _c("span", { on: { click: _vm.toNotice } }, [
                    _c("span", [_vm._v(_vm._s(_vm.msgNum))]),
                    _vm._v("条新消息")
                  ]),
                  _vm._v(" "),
                  _c("i", {
                    staticClass: "icon-del",
                    staticStyle: { "margin-left": "10px" },
                    on: {
                      click: function($event) {
                        _vm.visible = false
                      }
                    }
                  })
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("span", { staticClass: "welcome" }, [
            _vm._v("欢迎您，" + _vm._s(_vm.pUid) + "！")
          ]),
          _vm._v(" "),
          _c(
            "el-dropdown",
            { attrs: { trigger: "click" }, on: { command: _vm.handleCommand } },
            [
              _c("span", { staticClass: "user" }, [
                _vm._v("\n          " + _vm._s(_vm.pName)),
                _c("i", { staticClass: "icon-down" })
              ]),
              _vm._v(" "),
              _c(
                "el-dropdown-menu",
                { attrs: { slot: "dropdown" }, slot: "dropdown" },
                [
                  _c("el-dropdown-item", { attrs: { command: "out" } }, [
                    _vm._v("退出")
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("img", {
        staticClass: "logo",
        attrs: { src: _vm.logo },
        on: { click: _vm.toShopping }
      }),
      _vm._v(" "),
      _c("ul", { staticClass: "menu" }, [
        _c(
          "li",
          [
            _c("router-link", { attrs: { to: "/shopping" } }, [
              _vm._v("订货中心")
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "li",
          [
            _c("router-link", { attrs: { to: "/weekReport" } }, [
              _vm._v("业绩分析")
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "li",
          [_c("router-link", { attrs: { to: "/mine" } }, [_vm._v("我的服务")])],
          1
        ),
        _vm._v(" "),
        _c(
          "li",
          { staticStyle: { "margin-right": "0" } },
          [
            _c(
              "router-link",
              { staticClass: "cart-layout", attrs: { to: "/shoppingCart" } },
              [
                _c("span", { staticClass: "icon-gouwuche" }),
                _vm._v(" "),
                _vm.cartNum
                  ? _c("el-badge", {
                      staticClass: "badge",
                      attrs: { value: _vm.cartNum, max: 99 }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("span", { staticClass: "price" }, [
                  _vm._v(
                    "￥" + _vm._s(_vm.$util.formatThousand(_vm.totalPrice))
                  )
                ])
              ],
              1
            )
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6a1e17a8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a1e17a8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/common/header.vue
// module id = null
// module chunks = 